module.exports = __webpack_public_path__ + "static/investigations-eb9340d018f898b96e159cfb5f76f6c5.png";